<template>
  <div class="component-block">
    <div class="spin" v-if="loading">
      <LoadingSpinner/>
    </div>
    <NavigationView/>
    <div class="block-container">
      <div class="tableview-block">
        <div class="tableview-top">
          <div class="tableview-top-left">
            <div class="tableview-top-count">
              Уведомления {{ startLoading ? '' : `(${tableItems.length})` }}
            </div>
            <div class="tableview-top-search pc">
              <label>
                <svg class="tableview-top-search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
                      fill="#4D5460"/>
                </svg>
                <input v-model="searchValue" type="text" placeholder="Найти уведомление...">
                <button
                    @click="this.searchValue = ''"
                    v-if="searchValue !== ''"
                    class="tableview-top-search-close">
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"/>
                  </svg>
                </button>
              </label>
            </div>
          </div>
          <div>
            <button @click="clearFilters" class="clear-filters pc">
              Сбросить фильтры
            </button>
            <button @click="clearFilters" class="clear-filters mobile">
              <svg x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512"
                   xml:space="preserve" class="">
                <g>
                  <path
                      d="M19 13a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 19 13zm2.75 0A4.756 4.756 0 0 1 17 17.75a4.689 4.689 0 0 1-2.25-.593V21a.75.75 0 0 1-1.2.6l-4-3a.75.75 0 0 1-.3-.6v-4a.745.745 0 0 0-.221-.53L3.91 8.35a2.231 2.231 0 0 1-.66-1.59V4.5A2.253 2.253 0 0 1 5.5 2.25h13a2.253 2.253 0 0 1 2.25 2.25v2.26a2.235 2.235 0 0 1-.66 1.591l-.615.614A4.738 4.738 0 0 1 21.75 13zm-8.5 6.5v-3.619a4.7 4.7 0 0 1-1-2.881A4.756 4.756 0 0 1 17 8.25a4.692 4.692 0 0 1 .969.1l1.06-1.061a.745.745 0 0 0 .221-.53V4.5a.751.751 0 0 0-.75-.75h-13a.751.751 0 0 0-.75.75v2.26a.745.745 0 0 0 .221.53l5.119 5.12a2.231 2.231 0 0 1 .66 1.59v3.625zm7-6.5A3.25 3.25 0 1 0 17 16.25 3.254 3.254 0 0 0 20.25 13z"
                      opacity="1" data-original="#000000" class="">
                  </path>
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div class="tableview-top-search mobile">
          <label>
            <svg class="tableview-top-search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
                  fill="#4D5460"/>
            </svg>
            <input v-model="searchValue" type="text" placeholder="Найти уведомление...">
            <button
                @click="this.searchValue = ''"
                v-if="searchValue !== ''"
                class="tableview-top-search-close">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"/>
              </svg>
            </button>
          </label>
        </div>
        <div
            v-if="!startLoading"
            class="tableview-main"
        >
          <div
              class="tableview-main-left"
              :class="{ 'not-selected': itemsSelected.length === 0 }"
          >
            <EasyDataTable
                buttons-pagination
                :headers="tableHeaders"
                :items="tableItems"
                :search-value="searchValue"
                rows-of-page-separator-message="из"
                theme-color="#005291"
                table-class-name="customize-table"
                :filter-options="filterOptions"
                :rows-items=[25,50,100]
                :rows-per-page=25
            >

              <template #empty-message>
                Данные не найдены
              </template>

              <!-- carrier filter-->
              <template #header-carrierName="header">
                <div
                    class="filter-column"
                    :class="{ 'selected': carrierCriteria !== 'Все' }"
                >
                  <button class="filter-icon"
                          @click.stop="showCarrierFilter=!showCarrierFilter">
                    <FilterIcon v-if="carrierCriteria === 'Все'"/>
                    <FilterSelectedIcon v-if="carrierCriteria !== 'Все'"/>
                  </button>
                  {{ header.text }}
                  <div @click.stop class="filter-menu" v-if="showCarrierFilter">
                    <Multiselect
                        v-model="carrierCriteria"
                        :searchable="true"
                        :canDeselect="false"
                        :options="['Все', ...multiselectItems]"
                    />
                  </div>
                </div>
              </template>

            </EasyDataTable>
          </div>
        </div>
        <LoadingSpinner v-else/>
      </div>
    </div>
  </div>
</template>

<script>

import NavigationView from "@/components/NavigationView";
import store from "@/store";
import http from "@/http";
import LoadingSpinner from "@/components/LoadingSpinner";
import Multiselect from '@vueform/multiselect'
import FilterIcon from "@/components/icons/filter-icon.vue";
import FilterSelectedIcon from "@/components/icons/filter-selected-icon.vue";

export default {
  name: "NotificationView",
  beforeMount() {
    if (store.state.user.roles.length === 0) {
      this.$router.push('/login');
    }
  },
  mounted() {
    if (store.state.user.roles.length > 0) {
      this.fetchNotifications(true);
      this.startInterval();
    }
    document.addEventListener('click', this.onGlobalClick, { capture: true })
  },
  unmounted() {
    clearInterval(this.notificationsInterval);
    document.removeEventListener('click', this.onGlobalClick, { capture: true })
  },
  data() {
    return {
      startLoading: false,
      loading: false,
      searchValue: '',
      tableHeaders: [
        {text: "Тип уведомления", value: "notification_type", sortable: true},
        {text: "Текст уведомления", value: "message", sortable: true},
        {text: "Перевозчик", value: "carrierName", sortable: true},
        {text: "Гос. Номер", value: "carGosNumber", sortable: true},
      ],
      tableItems: [],
      multiselectItems: [],
      itemsSelected: [],
      carrierCriteria: 'Все',
      showCarrierFilter: false,
      notificationsInterval: '',
    };
  },
  computed: {
    filterOptions() {
      const filterOptionsArray = [];
      if (this.carrierCriteria !== 'Все') {
        filterOptionsArray.push({
          field: 'carrierName',
          comparison: '=',
          criteria: this.carrierCriteria,
        });
      }
      return filterOptionsArray;
    },

  },
  components: {
    NavigationView,
    LoadingSpinner,
    Multiselect,
    FilterIcon,
    FilterSelectedIcon,
  },
  methods: {
    async fetchNotifications(firstLoading) {
      try {
        if (firstLoading) {
          this.startLoading = true;
        }
        const responses = await Promise.all([
          http.get('/api/notify/notifications'),
        ]);
        if (responses[0].data !== null && responses[0].status === 200) {
          this.tableItems = responses[0].data;
          this.multiselectItems = [...(new Set(this.tableItems.map(e => {
            return e.carrierName;
          })))].sort(function (a, b) {
            if (a.toLowerCase() < b.toLowerCase()) {
              return -1;
            }
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            }
            return 0;
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.startLoading = false;
      }
    },
    startInterval() {
      this.notificationsInterval = setInterval(()=> {
        this.fetchNotifications(false);
      }, 300000)
    },
    clearFilters() {
      this.searchValue = '';
      this.itemsSelected = [];
      this.carrierCriteria = 'Все';
      this.showCarrierFilter = false;
    },
    closeAllFilters() {
      this.showCarrierFilter = false
    },
    onGlobalClick(e) {
      if (e.target.closest('.filter-menu') || e.target.closest('.filter-icon')) return
      this.closeAllFilters();
    },
  },
};
</script>

<style scoped>

.customize-table {
  --easy-table-row-border: 1px solid rgba(218, 218, 218, 0.5);
}

.spin {
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-container {
  /*background-image: url("../assets/images/backfon.jpg");*/
  /*background-size: cover;*/
  /*background-position: center;*/
  height: calc(100vh - 60px);
  height: calc(100dvh - 60px);
  /*padding: 30px;*/
  overflow: hidden;
}

.tableview-block {
  background: #FFFFFF;
  /*border-radius: 10px;*/
  height: 100%;
  position: relative;
  box-shadow: 0 5px 10px #aaacbd;
}

.tableview-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
}

.tableview-top-left {
  display: flex;
  align-items: center;
}

.tableview-top-count {
  font-size: 18px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #005291;
  margin-right: 20px;
}

.tableview-top-search.mobile {
  display: none;
}

.tableview-top-search label {
  position: relative;
  display: flex;
}

.tableview-top-search label input {
  background-color: #ffffff;
  box-shadow: 0px 0px 10px #dde5ed;
  border: 0;
  outline: none;
  border-radius: 10px;
  width: 350px;
  height: 38px;
  padding: 10px 42px 10px 48px;
  font-size: 14px;
  font-family: OpenSansRegular, sans-serif;
  color: #4D5460;
}

.tableview-top-search label input::placeholder {
  color: #4D5460;
}

.tableview-top-search-icon {
  position: absolute;
  top: 11px;
  left: 13px;
  pointer-events: none;
}

.tableview-top-search-close {
  position: absolute;
  background: transparent;
  border: 0;
  outline: none;
  top: 8px;
  right: 9px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tableview-top-search-close svg {
  fill: #4D5460;
}

.clear-filters {
  border-radius: 10px;
  color: #FF7C7C;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  outline: none;
  padding: 0 12px;
  border: 1px solid #FF7C7C;
  cursor: pointer;
  transition: all .4s;
}

.clear-filters.mobile, .button-add-transparent.mobile {
  display: none;
}

.button-add-transparent {
  border-radius: 10px;
  color: #4D5460;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  outline: none;
  padding: 0 12px;
  margin-right: 10px;
  border: 1px solid #DDE5ED;
  cursor: pointer;
  transition: all .4s;
}

.clear-filters:active, .download-btn:active, .delete-selected-btn:active, .button-add-transparent:active {
  transform: scale(0.95);
}

.download-btn {
  border-radius: 10px;
  color: #4D5460;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0 12px;
  border: 1px solid #DDE5ED;
  cursor: pointer;
  transition: all .4s;
  margin-right: 10px;
}

.download-btn .mobile {
  display: none;
}

.download-btn svg {
  margin-right: 8px;
}

.delete-selected-btn {
  border-radius: 10px;
  color: #FF7C7C;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0 12px;
  border: 1px solid #FF7C7C;
  cursor: pointer;
  transition: all .4s;
}

.delete-selected-btn svg {
  margin-right: 8px;
}

.tableview-main {
  display: flex;
  height: calc(100% - 68px);
}

.tableview-main-left {
  width: 100%;
  height: calc(100% - 122px);
}

.tableview-main-left.not-selected {
  height: calc(100% - 64px);
}

.tableview-main-selected {
  display: flex;
  align-items: center;
  margin-top: 43px;
  justify-content: space-between;
  padding: 20px 20px 20px 30px;
}

.tableview-main-selected-left {
  font-size: 14px;
  color: #4D5460;
}

.tableview-main-selected-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tableview-main-selected-actions-text {
  font-size: 14px;
  color: #4D5460;
  margin-right: 12px;
}

.model-container {
  position: relative;
  z-index: 4;
}

.status-point-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 4;
}

.status-point {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #418FDE;
}

.status-point.inactive {
  background: #C1C6C8;
}

.selected-field.selected {
  background: #DDE5ED;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
}

.tableview-main-right {
  background: #DDE5ED;
  padding: 17px 20px 20px 20px;
  max-width: 420px;
  /*border-radius: 0 0 10px 0;*/
  overflow: auto;
}

.tableview-main-right-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.tableview-main-right-name {
  font-family: OpenSansBold, sans-serif;
  font-size: 20px;
  color: #005291;
  margin-right: 15px;
}

.tableview-main-right-status {
  width: 18px;
  height: 18px;
  margin-left: auto;
  flex-shrink: 0;
  border-radius: 50%;
  background: #418FDE;
}

.tableview-main-right-status.inactive {
  background: #C1C6C8;
}

.tableview-main-right-info {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.tableview-main-right-model {
  font-size: 14px;
  color: #4D5460;
  margin-right: 10px;
}

.tableview-main-right-speed {
  background: #363636;
  border-radius: 10px;
  font-size: 14px;
  color: #ffffff;
  padding: 1px 10px;
}

.tableview-main-right-additional {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.tableview-main-right-additional-icon {
  margin-right: 10px;
}

.tableview-main-right-additional-label {
  margin-bottom: 3px;
  font-size: 12px;
  color: #9A9A9A;
}

.tableview-main-right-additional-value {
  font-size: 14px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #4D5460;
}

.tableview-main-right-divider {
  height: 1px;
  background: #C1C6C8;
  margin-top: 15px;
  margin-bottom: 20px;
}

.button-update {
  border-radius: 10px;
  color: #FFFFFF;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: #005291;
  width: 100%;
  height: 38px;
  outline: none;
  border: 0;
  padding: 0 12px;
  cursor: pointer;
  transition: all .4s;
}

.button-update:active {
  transform: scale(0.95);
}

.button-add {
  width: 100%;
  height: 38px;
  background: #005291;
  color: #ffffff;
  border: 0;
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  transition: all .4s;
}

.button-add:active {
  transform: scale(0.95);
}

.filter-column {
  display: flex;
  align-items: center;
  position: relative;
  font-family: OpenSansBold, sans-serif;
}

.filter-column svg {
  fill: #4D5460;
}

.filter-column.selected svg {
  fill: #005291;
}

.filter-icon {
  background: transparent;
  border: 0;
  outline: none;
  margin-right: 5px;
  cursor: pointer;
}

.filter-menu {
  position: absolute;
  width: 250px;
  top: 40px;
  left: 0;
  background: #ffffff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0px 0px 10px #dde5ed;
}

.ip-button {
  border-radius: 50%;
  background: transparent;
  border: 1px solid grey;
  color: grey;
  outline: none;
  flex-shrink: 0;
  margin-left: 5px;
  font-size: 13px;
  width: 30px;
  height: 30px;
  transition: all .4s;
}

.ip-button.active {
  border: 1px solid #005291;
  color: #005291;
}

.permanent-check {
  margin-top: 3px;
  font-size: 14px;
  color: #005291;
}

.permanent-check .form-check-input {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  margin-top: 2px;
}

.permanent-check .form-check-input:checked {
  background-color: #2C5697;
  border-color: #2C5697;
}

.edit-modal {
  display: none;
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  .tableview-main-right {
    display: none;
  }

  .edit-modal {
    display: initial;
  }

  .tableview-top-search label input {
    width: 300px;
  }
}

/* < 960 */
@media screen and (max-width: 959px) {

  /*верхняя строка*/
  .tableview-top-search.pc {
    display: none;
  }

  .tableview-top-search.mobile {
    display: block;
    padding: 0 20px 15px 20px;
  }

  .tableview-top-search label input {
    width: 100%;
  }

  /*таблица*/
  .tableview-main {
    display: flex;
    height: calc(100% - 121px);
  }
}

/* < 768 */
@media screen and (max-width: 767px) {
  .tableview-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
  }

  .tableview-top-search.mobile {
    display: block;
    padding: 0 15px 15px 15px;
  }

  .tableview-main-selected-actions-text {
    display: none;
  }

  .tableview-main-selected {
    padding: 20px 15px 20px 15px;
  }
}

/* < 620 */
@media screen and (max-width: 619px) {
  .tableview-top-count {
    font-size: 16px;
    margin-right: 0;
  }

  .button-add-transparent.mobile, .clear-filters.mobile {
    display: initial;
    padding: 0;
    width: 38px;
    height: 38px;
  }

  .button-add-transparent.mobile {
    border: 1px solid rgb(40, 189, 74);
  }

  .button-add-transparent.mobile svg {
    width: 20px;
    height: 20px;
  }

  .button-add-transparent.mobile svg {
    fill: rgb(40, 189, 74);
  }

  .clear-filters.mobile svg {
    width: 24px;
    height: 24px;
  }

  .clear-filters.mobile svg, .clear-filters.mobile svg path {
    fill: #FF7C7C;
  }

  .clear-filters.pc, .button-add-transparent.pc {
    display: none;
  }

  .delete-selected-btn {
    height: 38px;
    width: 38px;
    padding: 1px;
  }

  .delete-selected-btn span {
    display: none;
  }

  .delete-selected-btn svg {
    margin-right: 0;
  }

  .download-btn .pc {
    display: none;
  }

  .download-btn .mobile {
    display: initial;
  }

  .tableview-main-selected {
    padding: 15px;
  }

  .tableview-main-left {
    height: calc(100% - 110px);
  }

  .tableview-main-left.not-selected {
    height: calc(100% - 44px);
  }
}
</style>